<div class="relative flex w-full flex-wrap items-stretch mt-12">

    <input type="text" placeholder=" نام پزشک، نام بیماری، تخصص ... " #queryInput (keyup.enter)="onSearch(queryInput.value)"
        class="border-0 p-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded shadow  w-full">
    <button type="submit" (click)="onSearch(queryInput.value)"
        class="absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-gray-100 font-medium rounded-lg text-sm p-1 left-0">
        <img src="../../../assets/img/icon/Search_light.svg" class="w-10" alt="">
    </button>
</div>

<!-- <form>   
      <label for="search" class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
      <div class="relative">
          <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
              </svg>
          </div>
          <input type="search" id="search" class="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search" required />
          
      </div>
    </form> -->